import React from "react";
import { ref, deleteObject } from "firebase/storage";
import { storage } from "../../../../firebase";
import { Button } from "../../../../design/button";
import { TrashIcon } from "@heroicons/react/16/solid";
import { ClientFile } from "@visitproof/types";
import { useParent } from "../../../../contexts/ParentContext";
import { useDeleteAlert } from "../../../../contexts/DeleteAlertProvider";

type File = ClientFile;

interface DeleteFileButtonProps {
  parentId: string;
  file: File;
}

const DeleteParentFileButton: React.FC<DeleteFileButtonProps> = ({
  parentId,
  file,
}) => {
  const { deleteFileFromParent } = useParent();
  const { openAlert } = useDeleteAlert();

  const handleDelete = async (id: string) => {
    const fileRef = ref(storage, file.path);
    await deleteObject(fileRef);
    await deleteFileFromParent(parentId, id);
  };

  const handleClick = () => {
    openAlert(
      file,
      {
        displayName: "file",
        onDelete: handleDelete,
        getId: (entity) => entity.id,
      }
    );
  };

  return (
    <Button color="red" type="button" onClick={handleClick}>
      <TrashIcon className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
};

export default DeleteParentFileButton;
